import React, { useEffect, useState } from 'react';
import '../styles/Sobre.css';

const Sobre = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animação de fade-in ao carregar o componente
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500); // 500ms para aparecer suavemente
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`sobre-container ${isVisible ? 'fade-in' : ''}`}>
      <h2>Sobre mim</h2>
      <p>
        Olá! Sou Guilherme Guedes, designer gráfico com 4 anos de experiência ajudando marcas a se destacarem por meio de designs estratégicos. Combino criatividade com conhecimento técnico para desenvolver identidades visuais que conectam marcas ao seu público.
      </p>
      <p>
        Meu foco é entregar projetos que refletem a essência de cada cliente, sempre priorizando qualidade, originalidade e resultados.
      </p>
    </div>
  );
};

export default Sobre;
